import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
// Plugins
import { timer } from 'rxjs';

@Component({
	selector: 'sf-table-search',
	templateUrl: './table-search.component.html',
	styleUrls: ['./table-search.component.scss']
})
export class TableSearchComponent implements OnChanges {
	@Input() public state: boolean = false;
	@Input() public tableSearchValue: string = '';
	@Output() public searchOutput = new EventEmitter<string>();
	@Output() public resetOutput = new EventEmitter<string>();

	public searchValue: string = '';

	public ngOnChanges(): void {
		if (this.state) {
			this.searchValue = this.tableSearchValue?.trim();
			
			timer(100).subscribe(() => {
				(<HTMLInputElement>document.querySelector('input.search-input'))?.focus();
			});
		}
	}

	public reset(): void {
		this.searchValue = '';

		this.resetOutput.emit(this.searchValue);
	}

	public search(): void | boolean {
		this.searchOutput.emit(this.searchValue);
	}
}
